import { motion } from "framer-motion";

const Challenge = () => {
  return (
    <section
      id="momento"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(220 69% 2%), hsl(217 61% 6%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block"
            style={{ color: "#5BA3E0" }}
          >
            El Momento
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.1] text-white">
            Un trono vacío,
            <br />
            <span style={{ color: "#5BA3E0" }}>y vos ya sabés por qué.</span>
          </h2>
        </motion.div>

        {/* Paragraphs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="space-y-6 text-base md:text-lg text-white/75 leading-relaxed mb-10"
        >
          <p>
            Lo dijiste con una claridad que no necesita que la mejoremos: hay
            referentes de sobra que hablan de la Macro, pero nadie habla de la
            calle. Nadie habla de la micro, de la problemática real de la pyme,
            del que la pelea todos los días. Ese lugar está vacío.
          </p>
          <p>
            No está vacío por casualidad. Está vacío porque los que tienen el
            escenario, los grandes nombres de la economía, hablan otro idioma, y
            los que sí conocen la calle no lo construyeron como marca. Vos estás
            parado justo en esa intersección: conocés la pyme desde adentro,
            tenés la plataforma que la financia, y tenés la decisión de ocupar el
            lugar antes que nadie.
          </p>
        </motion.div>

        {/* Pull-quote */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="my-12 pl-6 md:pl-8 py-4 border-l-4"
          style={{ borderColor: "#5BA3E0" }}
        >
          <p className="font-display text-xl md:text-2xl lg:text-3xl font-semibold text-white leading-snug">
            Un lugar sin líder no es una posición: es una ventana.
            <br />
            Y las ventanas, se abren o se cierran.
          </p>
        </motion.div>

        {/* Closing box */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="rounded-2xl p-8 md:p-12 text-center border border-white/10"
          style={{
            background:
              "linear-gradient(135deg, hsl(220 69% 4%), hsl(217 61% 8%))",
          }}
        >
          <p className="text-base md:text-lg text-white/85 leading-relaxed">
            Tu objetivo lo dijiste sin vueltas: vender más. No figurar por
            figurar.
            <br />
            Esta propuesta está escrita en ese idioma. No hablamos de imagen ni de
            estética. Hablamos del{" "}
            <span style={{ color: "#1D9E75" }} className="font-semibold">
              activo comercial
            </span>{" "}
            que hace que la pyme te elija y como consecuencia, que los fondos te
            vean que sos elegido.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Challenge;
